import script from "./City.vue?vue&type=script&setup=true&lang=js"
export * from "./City.vue?vue&type=script&setup=true&lang=js"

import "./City.vue?vue&type=style&index=0&id=5a824328&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a824328"]])

export default __exports__